var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResendLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.499,
    height: 16.5,
    viewBox: "0 0 23.499 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_10_158",
    "data-name": "Component 10 \\u2013 158",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_14",
    "data-name": "Subtraction 14",
    d: "M11189.341,1565h-11.523a1.752,1.752,0,0,1-1.782-1.431l0-.022a.067.067,0,0,0-.031-.063v-10.966a2,2,0,0,1,.619-1.094,1.827,1.827,0,0,1,1.22-.424h12.38c1.306,0,2.656,0,3.986,0a1.739,1.739,0,0,1,1.734,1.318,1.812,1.812,0,0,1,.059.5v4.263a6.068,6.068,0,0,0-1-.083l-.18,0v-4c-.042.034-.061.049-.073.062l-1.229,1.218c-1.163,1.151-2.406,2.381-3.616,3.575-.059.059-.084.1-.084.142s.034.09.09.145l.088.087.067.067.581.575a6.036,6.036,0,0,0-.732.944l-.81-.824-.063-.064a.164.164,0,0,0-.107-.063c-.032,0-.064.02-.111.068-.229.234-.48.483-.745.739a2.924,2.924,0,0,1-3.81.287,6.144,6.144,0,0,1-.807-.742c-.08-.083-.16-.166-.241-.247-.062-.063-.105-.09-.149-.09s-.087.026-.154.093c-1.554,1.544-3.15,3.124-4.56,4.517l-.006.006c-.066.065-.136.126-.22.2l-.075.067-.054.048h11.055a6.035,6.035,0,0,0,.286,1.186Zm-12.08-12.019h0l-.07.067v9.92l0,0a.207.207,0,0,0,.046-.028l.7-.693,1.046-1.035c.918-.908,2.061-2.038,3.142-3.1.1-.1.06-.146,0-.213l-.013-.015-.174-.171-.282-.277c-.467-.459-1-.98-1.494-1.485-.8-.81-1.619-1.65-2.344-2.392l-.558-.571Zm.832-.8h0a.479.479,0,0,0,.144.217l.02.019q3.221,3.192,6.448,6.384a1.783,1.783,0,0,0,.691.455,1.991,1.991,0,0,0,.624.107,1.841,1.841,0,0,0,1.327-.61c1.352-1.341,2.748-2.723,4.062-4.023l.58-.573,1.737-1.72c.043-.043.084-.087.13-.136l.013-.014.1-.105Z",
    transform: "translate(-11176.001 -1551)",
    fill: "#600097",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "md-refresh",
    transform: "translate(7.499 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13025",
    "data-name": "Path 13025",
    d: "M11.5,14.5a3,3,0,0,1,0-6,2.906,2.906,0,0,1,2.1.9L12,11h3.5V7.5L14.325,8.675a3.995,3.995,0,1,0,1.025,3.916H14.292A2.979,2.979,0,0,1,11.5,14.5Z",
    fill: "#7d7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendLink);
export default __webpack_public_path__ + "static/media/Resend Link.9b3849952c3512ea7526bffd6b38afb6.svg";
export { ForwardRef as ReactComponent };